// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"6931432b","453":"64d7e0f1","726":"c944f308","775":"1b0fbd9f"}[chunkId] + ".chunk.js";
};